module.exports = __webpack_public_path__ + "img/ChangePassword.e2e82de1.svg";